module.exports = __webpack_public_path__ + "static/img/mobilestep1.b9d94ff.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/front/mobilestep1.png
// module id = mR2o
// module chunks = 1